module.exports = __webpack_public_path__ + "static/media/feature.71407cd9.jpg";